import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IMakeRequest } from '../utils/make_request';
import { filterServerResponse } from './helpers';
import { mergeBaseUri } from '@cian/http-api/shared';

interface IGetAgentDataForCardResponse {
  data: {
    agent: IAgentSchema | null;
  } | null;
  status: 'ok';
}

export interface IGetAgentDataForCardOptions {
  apiBaseUrl: string;
  realtyUserId: number;
  subdomain: string;
}

export function getAgentDataForCard(
  makeRequest: IMakeRequest,
  options: IGetAgentDataForCardOptions,
): Promise<IGetAgentDataForCardResponse> {
  return makeRequest({
    method: 'GET',
    uri: mergeBaseUri(options.apiBaseUrl.replace('www', options.subdomain), {
      path: `/cian-api/site/v1/get-agent-data-for-card/`,
      query: `realtyUserId=${options.realtyUserId}`,
    }),
  })
    .then(filterServerResponse)
    .then(response => JSON.parse(response.responseBody));
}
